import { App, Button, Card, Col, Input, message, Pagination, Popconfirm, Row, Select, Space, Spin, Switch, Table, Tag, } from "antd";
import { EyeFilled, LoadingOutlined, DeleteOutlined, CheckOutlined, CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { useCallback, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { DELETE_SMTP, LIST_SMTP, SMTP_STATUS } from "../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../components/CulsightPageLoader";


function Smtp() {
  // STATES
  const { notification, modal } = App.useApp();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [table_data, set_table_data] = useState(false);
  const [current_page, set_current_page] = useState(
    Number(localStorage.getItem("smtp_page")) || 1
  );
  const [total_pages, set_total_pages] = useState("");
  const [total_smtps, set_total_smtps] = useState("");
  const [search_query_name, set_search_query_name] = useState(
    localStorage.getItem("smtp_search") || ""
  );

  const debounceRef = useRef(null);
  const [pageSize, setPageSize] = useState(10);


  // LIST API
  const LIST_API = async (
    page = current_page,
    per_page = pageSize,
    search = search_query_name
  ) => {
    const FORM_DATA = new FormData();

    FORM_DATA.append("page", page);
    FORM_DATA.append("per_page", per_page);

    if (search) {
      FORM_DATA.append("smtp_user", search);
    }

    const API_CALL = await LIST_SMTP(FORM_DATA);

    if (API_CALL?.data?.status) {
      set_table_data(API_CALL?.data?.data);
      set_current_page(API_CALL?.data?.current_page);
      set_total_pages(API_CALL?.data?.total_pages);
      set_total_smtps(API_CALL?.data?.total_smtps);
    }

    setLoader(false);
    set_pagination_loader(false);
  };


  useEffect(() => {
    LIST_API(
      Number(localStorage.getItem("smtp_page")) || 1,
      pageSize,
      localStorage.getItem("smtp_search") || ""
    );
  }, []);

  // SEARCH API 



  // SEARCH INPUT
  const handleInput = (e) => {
    const value = e.target.value;

    if (value && !search_query_name) {
      localStorage.setItem(
        "smtp_last_search_page",
        current_page
      );
    }

    set_search_query_name(value);

    localStorage.setItem(
      "smtp_search",
      value
    );

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {

      const pageToLoad = value
        ? 1
        : Number(
          localStorage.getItem(
            "smtp_last_search_page"
          )
        ) || 1;

      set_current_page(pageToLoad);

      LIST_API(
        pageToLoad,
        pageSize,
        value
      );

    }, 500);
  };


  const change_status = async (id) => {
    setLoader(true)
    const FORM_DATA = new FormData();
    FORM_DATA.append("id", id);
    try {
      const response = await SMTP_STATUS(FORM_DATA);
      if (response?.data?.status) {
        notification.success({
          message: "Successful",
          description: response?.data?.message,
        });
        await LIST_API(current_page, pageSize);

      } else {

      }
    } catch (error) {
      message.error(
        "Server Error: " + (error?.response?.data?.message || "Unknown error")
      );
    } finally {
      setLoader(false);
    }
  };

  const handleDelete = (id) => {

    modal.confirm({
      title: "Are you sure you want to delete this SMTP ?",
      okText: "Yes",
      cancelText: "No",
      onOk: async () => {
        setLoader(true)
        const FORM_DATA = new FormData();
        FORM_DATA.append("id", id);
        try {
          const response = await DELETE_SMTP(FORM_DATA);
          if (response?.data?.status) {
            message.success("Smtp  deleted successfully");

            await LIST_API(current_page, pageSize);
          } else {
            message.error("Failed to delete Smtp");

          }
        } catch (err) {
          message.error("Something went wrong");
        } finally {
          setLoader(false);
        }
      }
    });
  };



  // TABLE COLUMNS
  const columns = [
    {
      title: "Smtp Server",
      dataIndex: "smtp_server",
      render: (text, record) => (
        <span>
          {record.smtp_server}
        </span>
      ),
    },
    {
      title: "Smtp User",
      dataIndex: "smtp_user",
      render: (text, record) => <span>{record.smtp_user}</span>,
    },
    {
      title: "Smtp Port",
      dataIndex: "smtp_port",
      render: (text, record) => <span>{record.smtp_port}</span>,
    },
    {
      title: "Status",
      key: "status",
      render: (text, record) => (
        <span>
          {record.status ? (
            <>
              <Tag color="#1fa7a1" style={{ fontSize: "14px", padding: "4px 9px" }}
              >Active</Tag>
            </>
          ) : (
            <>
              <Tag color="red" style={{ fontSize: "14px", padding: "4px 9px" }}
              >Inactive</Tag>
            </>
          )}
        </span>
      ),
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            size="small"
            onClick={() => {
              localStorage.setItem("smtp_page", current_page);
              localStorage.setItem(
                "smtp_search",
                search_query_name
              );

              navigate("/edit-smtp/" + btoa(record.id));
            }}
          >
            <EyeFilled />
          </Button>

          <Popconfirm
            title={`Are you sure you want to ${record.status ? "deactivate" : "activate"
              } this SMTP?`}
            onConfirm={() => change_status(record?.id)}
            okText="Yes"
            cancelText="No"
          >
            <Switch
              checked={record.status}
              checkedChildren="Active"
              unCheckedChildren="Inactive"
              style={{
                backgroundColor: record.status ? "#52c41a" : "#ff4d4f",

              }}
            />
          </Popconfirm>

          <Button
            danger
            type="primary"
            size="small"
            onClick={() => handleDelete(record.id)}
          >
            <DeleteOutlined />
          </Button>
        </Space>
      ),
    }

  ];


  // PAGINATION API 
  const pagination_on_change = async (page) => {
    localStorage.setItem("smtp_page", page);

    set_pagination_loader(true);

    await LIST_API(
      page,
      pageSize,
      search_query_name
    );

    set_pagination_loader(false);
  };



  return (
    <div className="lms-body">


      <Row>
        <Col span={12}>
           <h1 style={{ margin: "5px", padding: "0px" }}>SMTP</h1>
        </Col>
        <Col span={12}>
          <div className="learner-buttons" style={{ float: "right" }}>
            <Button
              type="primary"
               size="large"
              style={{ marginRight: "10px" }}
              onClick={() => {
                localStorage.setItem("smtp_page", current_page);

                localStorage.setItem(
                  "smtp_search",
                  search_query_name
                );

                navigate("/add-smtp");
              }}
            >
              <PlusOutlined />
              Add SMTP
            </Button>

          </div>
        </Col>
      </Row>
      <Card>
        <Row>
          <Col span={12}>
            <Input
              addonBefore={<span>Name</span>}
              placeholder="Search by name"
              value={search_query_name}
              onChange={handleInput}
              size="large"
            />
          </Col>
        </Row>


        {loader ? (
          <>
            <CulsightPageLoader />
          </>
        ) : (
          <>
            {pagination_loader ? (
              <>
                <div style={{ textAlign: "center", padding: "60px" }}>
                  <Spin indicator={<LoadingOutlined spin />} size="large" />
                </div>
              </>
            ) : (
              <>
                <Table
                  columns={columns}
                  pagination={false}
                  dataSource={table_data}
                  style={{ marginTop: "15px" }}
                />
              </>
            )}

            {total_pages > 0 ? (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "15px",
                    marginTop: "20px",
                  }}
                >
                  <Pagination
                    current={current_page}
                    total={total_smtps}
                    pageSize={pageSize}
                    onChange={pagination_on_change}
                    showSizeChanger={false}
                  />

                  <Select
                    value={pageSize}
                    style={{ width: 120 }}
                    onChange={(value) => {
                      localStorage.setItem("smtp_page", 1);

                      setPageSize(value);
                      set_current_page(1);

                      LIST_API(
                        1,
                        value,
                        search_query_name
                      );
                    }}
                    options={[
                      { value: 10, label: "10 / page" },
                      { value: 20, label: "20 / page" },
                      { value: 50, label: "50 / page" },
                      { value: 100, label: "100 / page" },
                    ]}
                  />
                </div>
              </>
            ) : (
              <>

              </>
            )}
          </>
        )}
      </Card>
    </div>
  );
}

export default Smtp;
